import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { parseCssExports } from 'utils/commonUtils';

function importCSS(source, prefix) {
  return parseCssExports(source, { prefix, transform: i => i });
}

const SIZES = {
  ...importCSS(require('modules/News/components/MoreNewsList.scss'), 'moreNewsImageSizes'),
  ...importCSS(require('modules/News/components/Article.scss'), 'articlePageImageSizes'),
  ...importCSS(require('modules/Common/components/TipsSection.scss'), 'tipsSectionImageSizes'),
  ...importCSS(require('modules/Common/components/NewsSection.scss'), 'newsSectionImageSizes'),
  ...importCSS(require('modules/Common/components/TipsWidget/TipsWidget.scss'), 'tipsWidgetImageSizes'),  
};

const DEFAULT_SIZES = {
  leadArticle: 630,
  secondaryArticle: 450,
  otherArticle: 300,
  articlePage: 930,
  tipArticle: 320,
  tipWidget: 300,
  tipWidgetLarge: 289,
  sectionArticle: 250
}

// These values need to be unique.
const IMAGE_TYPES = [
  "leadArticle",
  "secondaryArticle",
  "otherArticle",
  "articlePage",
  "tipArticle",
  "tipWidget",
  "tipWidgetLarge",  
  "sectionArticle"
].map(s => ({
  type: s,
  sizes: SIZES[s],
  default: DEFAULT_SIZES[s]
}));

require('./Image.scss');

const getRatio = (width, height) => {
  return Number(width / height).toFixed(1);
}

const getImagesAtRatio = (images, ratio) => {
  return images.filter((i) => {
    const r = getRatio(i.width, i.height);
    const diff = Math.abs(Math.round((r - ratio) * 10));

    return diff <= 1;
  });
}

export default function Image({
  imageMedia: {
    artefacts = [],
    caption
  } = {},
  imageType,
  ratio
}) {

  let images = artefacts.filter(artefact => artefact.media_type === 'Image');
  // If no images exist within the artefacts display a placeholder image.
  if (images.length === 0) {

     const errorPixelSrc = `/1x1.gif?type=image&id=0&cb=${Date.now()}`;
    return (
      <div className="missing-image">
      <span>Image Missing</span>
      <img src={errorPixelSrc} width="1" height="1"/>
      </div>
    );
  }

  // Get the orignal image.
  const original = images.filter(artefact => isArtefactOriginal(artefact));

  // Get the processed images.
  images = images.filter(artefact => !isArtefactOriginal(artefact));

  // If we have no processed images, best we can do is display the orignal
  // whatever its aspect ratio.
  if (images.length === 0) {
    images = original;
  } else if (ratio) {
    images = getImagesAtRatio(images, ratio);
  }

  if (!images || images.length == 0) {
    images = original;
  }

  // Make sure we have the given image type in the list.
  const imageObject = _.find(IMAGE_TYPES, o => o.type == imageType);
  if (imageObject) {
    const imageSrc = findBestImageMatch(imageObject.default, images);

    const imgAttrs = {
      src: `/${encodeURI(imageSrc.uri)}`,
      sizes: imageObject.sizes,
      srcSet: images.map(image => `/${encodeURI(image.uri)} ${image.width}w`).join()
    };

    if (caption.trim()) {
      imgAttrs.alt = caption;
      imgAttrs.className = "image--with-caption"
    }

    return (
      <img {...imgAttrs} />
    );
  }

  // Return without a source set if an image type was not defined. We have no
  // information on what type of image here so just display a resonable default.
  const defaultSrc = findBestImageMatch(1000, images);
  return (
    <img src={`/${encodeURI(defaultSrc.uri)}`} />
  );
}

Image.propTypes = {
  imageMedia: PropTypes.object,
  imageType: PropTypes.string,
  ratio: PropTypes.number
}

function findBestImageMatch(targetWidth, images) {

  const imagesLower = [];
  const imagesHigher = [];
  images.map(image => {
    if (image.width < targetWidth) {
      imagesLower.push(image);
    } else {
      imagesHigher.push(image);
    }
  });

  // Return the first element.
  return [
    ..._.sortBy(imagesHigher, image => image.width),
    ..._.sortBy(imagesLower, image => image.width).reverse()
  ][0];

}

// Function to check if an artefact is an orginal or has a different
// aspect ratio to 16 / 9
function isArtefactOriginal(artefact) {
  const aspectRatio = artefact.width / artefact.height;
  return artefact.uri.includes("images/news/original") ||
         (aspectRatio > 16 / 9 + 0.02 && aspectRatio < 16 / 9 - 0.02); // Include margin of error
}

export function getFBImage(artefacts) {
  return findBestImageMatch(1200, artefacts.filter(artefact => artefact.media_type === 'Image'));
}



// WEBPACK FOOTER //
// ./modules/Common/components/Image.js